import React from 'react';
import { TESTIMONIES } from '../mock';
import { Sentences } from '../lib/text';
import { Quote, Star, ShieldCheck, Play } from 'lucide-react';
import { useState } from 'react';

export default function TestimoniesPage() {
  const [active, setActive] = useState(null);

  return (
    <div>
      <div className="relative border-b border-white/5">
        <div className="absolute inset-0 stars-bg twinkle" />
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="relative mx-auto max-w-[1400px] px-6 py-8">
          <div className="mono text-[10px] tracking-[0.2em] text-violet-300/90 uppercase mb-2">Témoignages sous serment · Pilotes et officiers</div>
          <h1 className="serif text-3xl md:text-4xl">La parole des <span className="italic text-violet-300">témoins militaires</span></h1>
          <p className="text-2 mt-2 max-w-3xl text-sm">Pilotes de chasse, officiers du renseignement, sénateurs et hauts responsables ayant témoigné publiquement, souvent sous serment, devant le Congrès américain.</p>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 py-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {TESTIMONIES.map(t => (
            <div key={t.id} className="glass rounded-lg p-4 doc-card relative overflow-hidden flex flex-col">
              <Quote className="absolute -right-2 -top-2 h-20 w-20 text-cyan-300/5" />
              <div className="flex items-start gap-3 mb-3">
                <div className="relative shrink-0">
                  <div className="h-12 w-12 rounded-full overflow-hidden border-2 border-cyan-300/40 bg-black">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="absolute -bottom-1 -right-1 bg-emerald-500/20 border border-emerald-400/40 rounded-full p-0.5">
                    <ShieldCheck className="h-2.5 w-2.5 text-emerald-300" />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-1 font-medium text-sm leading-snug">{t.name}</div>
                  <div className="text-3 text-xs">{t.role}</div>
                  {t.rank && <div className="mono text-[10px] text-amber-300/80 mt-0.5">{t.rank}</div>}
                  <div className="flex items-center gap-0.5 mt-1">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} className={`h-2.5 w-2.5 ${i < t.credibility ? 'text-amber-300 fill-current' : 'text-white/15'}`} />
                    ))}
                  </div>
                </div>
              </div>
              <div className="text-1 leading-relaxed serif text-sm italic mb-3 flex-1">
                <span className="text-cyan-300/70">«</span>
                <Sentences text={t.quote} className="inline" />
                <span className="text-cyan-300/70">»</span>
              </div>
              {t.bio && <Sentences text={t.bio} className="text-3 text-[11px] leading-relaxed mb-3" />}
              <div className="flex items-center justify-between pt-2 border-t border-white/5 text-[10px] mono text-3 gap-2">
                <span className="truncate">{t.incident}</span>
                <div className="flex items-center gap-2 shrink-0">
                  <span>{t.date}</span>
                  {t.youtubeId && (
                    <button onClick={()=>setActive(t)} className="inline-flex items-center gap-1 text-cyan-300 hover:text-cyan-200 px-1.5 py-0.5 rounded border border-cyan-300/30">
                      <Play className="h-2.5 w-2.5" fill="currentColor" /> Vidéo
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-50 bg-black/85 backdrop-blur-md flex items-center justify-center p-4" onClick={()=>setActive(null)}>
          <div className="relative w-full max-w-4xl" onClick={e => e.stopPropagation()}>
            <button onClick={()=>setActive(null)} className="absolute -top-10 right-0 text-2 hover:text-1 text-sm">Fermer ✕</button>
            <div className="aspect-video bg-black rounded-xl overflow-hidden border border-white/10">
              <iframe className="w-full h-full"
                src={`https://www.youtube.com/embed/${active.youtubeId}?autoplay=1&cc_load_policy=1&cc_lang_pref=fr`}
                title={active.name} allowFullScreen />
            </div>
            <div className="mt-2 glass rounded-md p-3 text-sm">
              <div className="text-1 font-medium">{active.name} — {active.incident}</div>
              <p className="text-2 italic mt-1 text-xs">« {active.quote} »</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
